import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';


const config = {
  apiKey: process.env.REACT_APP_apiKey,
  authDomain: process.env.REACT_APP_authDomain,
  projectId: process.env.REACT_APP_projectId,
  storageBucket: process.env.REACT_APP_storageBucket,
  messagingSenderId: process.env.REACT_APP_messagingSenderId,
  appId: process.env.REACT_APP_appId,
  measurementId: process.env.REACT_APP_measurementId
};

firebase.initializeApp(config);
firebase.firestore();
// firebase.firestore().enablePersistence()
firebase.storage();


if (location.hostname === "localhost") {
  firebase.functions().useEmulator("127.0.0.1", 5001);
   
}


export default firebase;
